import React from 'react'

// material ui forms
import FormHelperText from '@mui/material/FormHelperText'

// shared components
import FormDatePickerWithValidation from 'components/shared/FormDatePickerWithValidation'

const BirthdateForm = props => {
  const {
    // via EditCamperContainer:
    form, // via redux state
    formErrors, // via withFormResults

    // via CamperFormContainer:
    onChangeDateField // via withEventHandlers
  } = props

  return (
    <FormDatePickerWithValidation
      label='Birthdate'
      form={form}
      field='birthdate'
      onChange={onChangeDateField}
      errors={formErrors}
      required
    >
      <FormHelperText>MM/DD/YYYY</FormHelperText>
    </FormDatePickerWithValidation>
  )
}

export default BirthdateForm
